/**
 * @prettier
 */
export function nonUndefined<T>(value: T | undefined): value is T {
    return value !== undefined;
}
